import { render, staticRenderFns } from "./NewsDetail1920.vue?vue&type=template&id=72d36c22&scoped=true"
import script from "./NewsDetail1920.vue?vue&type=script&lang=js"
export * from "./NewsDetail1920.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail1920.vue?vue&type=style&index=0&id=72d36c22&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d36c22",
  null
  
)

export default component.exports